// extracted by mini-css-extract-plugin
export default {"root":"SelectTaxonomy_root__ty4Gl","loader":"SelectTaxonomy_loader__YpDx1","nodeButton":"SelectTaxonomy_nodeButton__DhsIY"};